<template>
  <div class="activation-summary">
    <slot name="txtHeader">
      <h1>MOBIL SIM-KARTE AKTIVIEREN</h1>
      <p>
        Nachfolgend finden Sie alle eingegebenen Daten in der Zusammenfassung. Bitte kontrollieren Sie Ihre Angaben.
        Sie können diese durch Klicken auf den Button „zurück“ korrigieren. Wenn alle Eingaben richtig sind, klicken
        Sie auf „Aktivieren“
      </p>
    </slot>
    <div class="content">
      <ShowPersonalData :customer="getCustomer">
        <template #txtBefore><slot name="txtBeforePersonalDataParent"></slot></template>
        <template #lblSalutationWrapper><slot name="lblSalutationParent"></slot></template>
        <template #lblFirstNameWrapper><slot name="lblFirstNameParent"></slot></template>
        <template #lblLastNameWrapper><slot name="lblLastNameParent"></slot></template>
        <template #lblStreetNumberWrapper><slot name="lblStreetNumberParent"></slot></template>
        <template #lblZipCityWrapper><slot name="lblZipCityParent"></slot></template>
        <template #lblSupplementWrapper><slot name="lblSupplementParent"></slot></template>
        <template #lblBirthDateWrapper><slot name="lblBirthDateParent"></slot></template>
        <template #lblEmailWrapper><slot name="lblEmailParent"></slot></template>
      </ShowPersonalData>
      <PersonalDataIdentSummary>
        <template #lblNationality><slot name="lblNationalityParent"></slot></template>
        <template #lblIdentCard><slot name="lblIdentCardParent"></slot></template>
        <template #lblIdentType><slot name="lblIdentTypeParent"></slot></template>
        <template #txtIdentTypevideo><slot name="txtIdentTypevideoParent">Identifikation über Video Anruf</slot></template>
        <template #txtIdentTypestore><slot name="txtIdentTypestoreParent">Identifikation in einer Postfiliale</slot></template>
      </PersonalDataIdentSummary>
      <PaymentInformation :payment="_payment">
        <template #txtBefore><slot name="txtBeforePayment"></slot></template>
        <template #txtBeforeCreditCard><slot name="txtBeforeCreditCardPayment"></slot></template>
        <template #lblCcHolderCreditCard><slot name="lblCcHolderCreditCardPayment"></slot></template>
        <template #lblCcNumberCreditCard><slot name="lblCcNumberCreditCardPayment"></slot></template>
        <template #lblCcTypeCreditCard><slot name="lblCcTypeCreditCardPayment"></slot></template>
        <template #lblCcValidtyCreditCard><slot name="lblCcValidtyCreditCardPayment"></slot></template>
        <template #txtAfterCreditCard><slot name="txtAfterCreditCardPayment"></slot></template>
        <template #txtErrorCreditCard><slot name="txtErrorCreditCardPayment"></slot></template>
        <template #txtBeforeBankAccount><slot name="txtBeforeBankAccountPayment"></slot></template>
        <template #lblOwnerBankAccount><slot name="lblOwnerBankAccountPayment"></slot></template>
        <template #lblIbanBankAccount><slot name="lblIbanBankAccountPayment"></slot></template>
        <template #txtAfterBankAccount><slot name="txtAfterBankAccountPayment"></slot></template>
        <template #txtAfter><slot name="txtAfterPayment"></slot></template>
      </PaymentInformation>
      <ConsentWrapper
        :consentAGB.sync="consent.agb"
        :consentInformationArticle.sync="consent.informationArticle"
        :selectedInfoExchangeConsent.sync="consent.exchange"
        :selectedContactConsent.sync="consent.contact"
        :contractTermsVersion.sync="consent.contractTermsVersion"
      >
        <template #txtAGBWrapper><slot name="txtAGBParent"></slot></template>
        <template #lblAgbConsentWrapper><slot name="lblAgbConsentParent"></slot></template>
        <template #lblSmartphoneInformationArticleWrapper><slot name="lblSmartphoneInformationArticleParent"></slot></template>
        <template #lblFriendsInformationArticleWrapper><slot name="lblFriendsInformationArticleParent"></slot></template>
        <template #txtConsultationConsentWrapper><slot name="txtConsultationConsentParent"></slot></template>
        <template #txtIndicationContractData><slot name="txtIndicationContractDataParent"></slot></template>
      </ConsentWrapper>
      <TariffOptionsSummaryWrapper>
        <template #txtTariffOptionsHeader><slot name="txtTariffOptionsHeaderParent"></slot></template>
        <template #txtCosts><slot name="txtCostsParent"></slot></template>
        <template #txtLink><slot name="txtLinkParent"></slot></template>
        <template #txtRuntime><slot name="txtRuntimeParent"></slot></template>
        <template #txtSumWrapper><slot name="txtSumWrapperParent"></slot></template>
        <template #txtPaymentTariffOptions><slot name="txtPaymentTariffOptionsParent"></slot></template>
      </TariffOptionsSummaryWrapper>
      <TopUpSummaryWrapper>
        <template #txtMonthlyHeaderWrapper><slot name="txtMonthlyHeaderParent"></slot></template>
        <template #txtTopUpAmountWrapper><slot name="txtTopUpAmountParent"></slot></template>
        <template #txtMonthlyDescWrapper><slot name="txtMonthlyDescParent"></slot></template>
        <template #txtByLimitHeaderWrapper><slot name="txtByLimitHeaderParent"></slot></template>
        <template #txtTopUpTriggerByLimitWrapper><slot name="txtTopUpTriggerByLimitParent"></slot></template>
        <template #txtTopUpAmountByLimitWrapper><slot name="txtTopUpAmountByLimitParent"></slot></template>
        <template #txtByLimitDescWrapper><slot name="txtByLimitDescParent"></slot></template>
      </TopUpSummaryWrapper>
    </div>
    <Stepper
      @prev="prev()"
      @next="next()"
      :loading-next="loading"
      :disabledNext="disabledNext && !loading"
      :show-prev="true"
    >
      <template #btnPrev><slot name="btnPrev"></slot></template>
      <template #btnNext><slot name="btnNext"></slot></template>
    </Stepper>
  </div>
</template>

<script>
import { stepName as nextStep } from '../Success/Success.vue'
import { stepName as previousStep } from './ActivationAutoTopUpAndPayment.vue'
import processSteps from '@/mixins/processSteps'
import PaymentInformation from '@/components/process/ROSSMANN/Activation/Wrapper/PaymentInformation.vue'
import ConsentWrapper from './ConsentWrapper.vue'
import TopUpSummaryWrapper from './TopUpSummaryWrapper.vue'
import TariffOptionsSummaryWrapper from './TariffOptionsSummaryWrapper.vue'
import PersonalDataIdentSummary from '../Summary/PersonalDataIdentSummary.vue'
import Stepper from '@/components/generic/Stepper.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ShowPersonalData from '@/components/process/generic/PersonalData/ShowPersonalData.vue'

export const stepName = 'summary'

export default {
  name: 'Summary',
  mixins: [
    processSteps(stepName, previousStep, nextStep)
  ],
  data () {
    return {
      loading: false,
      consent: {
        agb: false,
        informationArticle: false,
        exchange: false,
        contact: false,
        contractTermsVersion: null
      }
    }
  },
  computed: {
    _payment: function () {
      return {
        ...this.payment,
        type: this.payment.paymentType
      }
    },
    disabledNext: function () {
      return !this.consent.agb || !this.consent.informationArticle
    },
    ...mapGetters('activation/payment', [
      'payment'
    ]),
    ...mapGetters('activation/personalData', [
      'personal',
      'address',
      'additional'
    ]),
    getCustomer () {
      return {
        salutation: this.personal.gender,
        firstName: this.personal.firstName,
        lastName: this.personal.lastName,
        birthDate: this.personal.birthDate,
        email: this.additional.email,
        address: this.address
      }
    }
  },
  methods: {
    ...mapMutations('activation', [
      'goToStep'
    ]),
    ...mapActions('activation/submit', [
      'activationConfirm'
    ]),
    prev () {
      this.goToStep(this.previousStep)
    },
    async next () {
      this.loading = true
      await this.activationConfirm({ nextStep: this.nextStep, consents: this.consent })
      this.loading = false
    }
  },
  components: {
    ConsentWrapper,
    PaymentInformation,
    TopUpSummaryWrapper,
    TariffOptionsSummaryWrapper,
    PersonalDataIdentSummary,
    Stepper,
    ShowPersonalData
  }
}
</script>
